"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getParagraph;
function getParagraph(isParagraph, theme) {
  if (isParagraph) {
    return "padding-bottom: ".concat(theme.typographyPaddingBottomParagraph, ";");
  }
  return undefined;
}